import { render, staticRenderFns } from "./ReportSurveyScreen.vue?vue&type=template&id=31f251ec&scoped=true&"
import script from "./ReportSurveyScreen.vue?vue&type=script&lang=js&"
export * from "./ReportSurveyScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f251ec",
  null
  
)

export default component.exports